/* eslint-disable camelcase */
import PropTypes from 'prop-types';

const propTypesSliceVideo = {
  has_control: PropTypes.bool,
  video_caption: PropTypes.string,
  video_id: PropTypes.string,
  video_slice_id: PropTypes.string,
  video_title: PropTypes.string,
};

export const propTypesDataVideo = {
  id: PropTypes.string,
  slice_type: PropTypes.string,
  slice_label: PropTypes.string,
  primary: PropTypes.shape(propTypesSliceVideo),
};
